import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export type AttachmentType = 'screenshot' | 'company_document';

@Component({
  selector: 'app-attachment-type-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title class="atd-title">What type of attachment is this?</h2>
    <mat-dialog-content class="atd-content">
      <div class="atd-options">
        <button class="atd-option" (click)="select('screenshot')">
          <mat-icon class="atd-option-icon screenshot-icon">photo_camera</mat-icon>
          <div class="atd-option-text">
            <span class="atd-option-label">Screenshot / Quick Attachment</span>
            <span class="atd-option-desc">Attach directly to the conversation only</span>
          </div>
        </button>
        <button class="atd-option" (click)="select('company_document')">
          <mat-icon class="atd-option-icon document-icon">folder</mat-icon>
          <div class="atd-option-text">
            <span class="atd-option-label">Company Document</span>
            <span class="atd-option-desc">Upload to DMS and attach to the conversation</span>
          </div>
        </button>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .atd-title {
      font-size: 16px;
      font-weight: 600;
      margin: 0;
      padding: 20px 24px 8px;
    }
    .atd-content {
      padding: 8px 24px 16px !important;
    }
    .atd-options {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .atd-option {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px;
      border: 1.5px solid #e0e0e0;
      border-radius: 10px;
      background: #fff;
      cursor: pointer;
      transition: all 0.15s ease;
      text-align: left;
      width: 100%;
    }
    .atd-option:hover {
      border-color: #4caf50;
      background: #f6faf6;
    }
    .atd-option-icon {
      font-size: 32px;
      width: 32px;
      height: 32px;
    }
    .screenshot-icon {
      color: #ff9800;
    }
    .document-icon {
      color: #4caf50;
    }
    .atd-option-text {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .atd-option-label {
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }
    .atd-option-desc {
      font-size: 12px;
      color: #888;
    }
  `],
})
export class AttachmentTypeDialogComponent {
  constructor(private dialogRef: MatDialogRef<AttachmentTypeDialogComponent>) {}

  select(type: AttachmentType): void {
    this.dialogRef.close(type);
  }
}
